<template>
  <div v-if="sportBanners.length">
    <v-col
      cols="12"
      md="12"
      v-for="(ad, index) of sportBanners"
      class="no-padding ad"
      :key="index + '_ad'"
    >
      <img :src="ad.image" class="" :alt="ad.name" />
    </v-col>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { isMobileOnly, isTablet } from 'mobile-device-detect'
import axios from 'axios'
// import _ from "lodash"

export default {
  name: 'ImagesAds',
  data: () => ({
    isMobileOnly: isMobileOnly,
    isTablet: isTablet,
    pathImages: process.env.VUE_APP_URL_CLOUDFRONT,
    sportBanners: [],
  }),

  computed: {
    ...mapGetters({
      getAuthenticated: 'user/getAuthenticated',
      getId: 'user/getId',
      getLogin: 'user/getLogin',
      getPlatformSettings: 'settings/getPlatformSettings',
      getBanners: 'settings/getBanners',
    }),
  },
  watch: {
    getBanners(val) {
      if (val.length > 1) {
        const banners = val
        _.forEach(banners, bann => {
          if (bann.type == 0 && bann.slider_dx_banner_bottom == 1) {
            this.sportBanners.push({
              image: bann.image,
              link: bann.link,
              title: bann.name,
            })
          }
        })
      }
    },
  },
  methods: {
    ...mapActions({}),
  },

  async beforeCreate() {},
  async mounted() {},
}
</script>

<style type="text/css">
.ad {
  text-align: center;
  margin-top: 10px !important;
  width: 100% !important;
}
</style>
